import { showLoginToast } from './toastUtils';

export const handleGuestNavigation = (canAccess, path, navigate, options = {}) => {
    if (!canAccess(path)) {
        showLoginToast('Please log in to access this page');
        return false;
    }
    // Always navigate with the provided options, which includes state
    navigate(path, options);
    return true;
}; 